/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CARD_GAP, REFETCH_CONFIGURATION } from "../../../utils/constants";
import BackButton from "../../feedBacks/BackButton";
import StatsCard from "../../Cards/statsCard";
import VoltageProfileChart from "../../Charts/VoltageProfileChart";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import Loader2 from "../../feedBacks/loader2";
import { IHierarchicalNode } from "../../../utils/interfaces";
import { useAppSelector } from "../../../store/hooks";
import { useEffect, useState } from "react";
import LoadProfileChart from "../../Charts/LoadProfileChart";
import CurrentProfileChart from "../../Charts/CurrentProfileChart";
import AppSelect2 from "../../Inputs/AppSelect2";
import OperationSite from "./site";
import LevelDetailTable from "../../Table/LevelDetail";
import { formatCustomDateDayMonthYear } from "../../../utils/utils";
import { useUtils } from "../../../customHooks/useUtils";

function AggregateDashboardComponent({ level_id }: { level_id: string }) {
  const { t } = useUtils();
  
  const {
    data: classificationData,
    isLoading: classificationDetailLoading,
    error: classificationError,
  } = useFetchData<IHierarchicalNode>(
    ["/classifications", "fetchClassificationDetial", level_id],
    `/classifications/${level_id}/`,
    {},
    // @ts-ignore
    {}
  );

  // Add state to track selected option
  const [selectedOption, setSelectedOption] = useState({
    value: "all",
    label: t("common.all"),
  });

  // Handle select change
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption({
      value: e.target.value,
      label: e.target.options[e.target.selectedIndex].text,
    });
  };

  return (
    <div
      className="flex flex-col w-full h-full min-h-full"
      style={{ gap: CARD_GAP }}
    >
      <div className="w-full flex flex-col items-start gap-6 self-start justify-between">
        <div className="w-[80%] sm:w-[30%] flex items-center">
          <BackButton showBackText={false} />
          {classificationDetailLoading ? (
            <Loader2 />
          ) : classificationError ? (
            <div className="text-red-500">Error fetching detail</div>
          ) : classificationData?.name ? (
            <span className="text-primary-blackLight text-md ml-2 min-w-[500px]">
              {classificationData.parent &&
                classificationData.parent?.length > 0 && (
                  <>
                    {classificationData.parent.map(
                      (parent: any, index: number) => (
                        <span key={parent.id || index}>
                          {parent.name}
                          {classificationData.parent &&
                            index < classificationData.parent.length - 1 && (
                              <span className="mx-1 text-primary-blackLighter">
                                {"   "}● {"   "}
                              </span>
                            )}
                        </span>
                      )
                    )}
                    <span className="mx-1 text-primary-blackLighter">
                      {"   "}● {"   "}
                    </span>
                  </>
                )}

              <span className="font-bold text-primary-blackLight">
                {classificationData.name}
              </span>

              {selectedOption.label !== t("common.all") && (
                <span className="font-bold text-primary-blackLight">
                  {"     "}● {selectedOption.label}
                </span>
              )}
            </span>
          ) : null}
        </div>
        <AppSelect2
          label=""
          className="max-w-[150px] text-primary-blackMain"
          selectWrapperStyle="border-primary-yellowMain !text-primary-blackMain"
          //   selectStyle="bg-inherit"
          options={
            classificationData?.devices
              ? [
                  { value: "all", label: t("common.all") },
                  ...classificationData.devices
                    .sort((a, b) => a.asset_name.localeCompare(b.asset_name))
                    .map((device) => ({
                      value: device.id,
                      label: device.asset_name,
                    })),
                ]
              : []
          }
          value={selectedOption.value}
          onChange={handleSelectChange}
        />
      </div>

      {selectedOption.value === "all" ? (
        <AggregateDashboardSubComponent
          key="aggregate-dashboard"
          level_id={level_id}
          classificationData={classificationData as IHierarchicalNode}
          isclassificationDataLoading={classificationDetailLoading}
          error={classificationError}
        />
      ) : (
        <OperationSite
          key={`operation-site-${selectedOption.value}`}
          site_id={selectedOption.value}
          from_aggregate={true}
        />
      )}
    </div>
  );
}
export default AggregateDashboardComponent;

const AggregateDashboardSubComponent = ({
  level_id,
  classificationData,
  isclassificationDataLoading,
  error,
}: {
  level_id: string;
  classificationData: IHierarchicalNode;
  isclassificationDataLoading: boolean;
  error: any;
  }) => {
  const language = useAppSelector((state) => state.language.language);
  const { t } = useUtils();
  const excludeCards = [t("readings.unknown")];
  const { mapResponseToLabelValue, INSTATAENOUS_KPIS } = useUtils();
  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  // Fetch operations data with React Query
  const {
    data: operationsData,
    isLoading: operationsLoading,
    error: operationsError,
    refetch,
  } = useFetchData(
    ["/level", "fetchSiteByLevel", level_id],
    `/operations/classification/${level_id}`,
    {
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );

  // Fetch site details with React Query

  const isLoading =
    // Show loading for initial page load
    operationsLoading ||
    // Show loading when filter is applied and when actually refetching
    isLocalLoading;

  useEffect(() => {
    if (startDate && endDate) {
      setIsLocalLoading(true);

      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [startDate, endDate, refetch]);
  // Transform operations data using React Query's data
  const transformedData = operationsData
    ? mapResponseToLabelValue(operationsData)
    : [];

  // Render stats cards
  const renderStatsCards = (dataSlice: any[], noOfLoadBox: number) => {
    if (isLoading) {
      return Array.from({ length: noOfLoadBox }).map((_, index) => (
        <StatsCard
          key={`loading-${index}`}
          title=""
          value=""
          isError={false}
          isLoading={true}
        />
      ));
    }

    if (operationsError) {
      return Array.from({ length: 4 }).map((_, index) => (
        <StatsCard
          key={`error-${index}`}
          title=""
          value=""
          isError={true}
          isLoading={false}
          cardErrorStyle="!h-[50px]"
        />
      ));
    }

    return dataSlice.map(
      (data: any, index: number) =>
        !excludeCards.includes(data.label) && (
          <div key={`stat-${index}`}>
            <StatsCard
              title={data.label}
              value={data.value as string}
              time={
                INSTATAENOUS_KPIS.includes(data.label)
                  ? (operationsData as any).time
                  : ""
              }
              period={!INSTATAENOUS_KPIS.includes(data.label) ? formatCustomDateDayMonthYear(startDate, endDate, language) : ""}
                              
              isError={false}
              isLoading={false}
            />
          </div>
        )
    );
  };

  return (
    <div
      className="flex flex-col w-full h-full min-h-full"
      style={{ gap: CARD_GAP }}
    >
      <div
        className="flex flex-wrap justify-between lg:justify-start items-center w-full"
        style={{ gap: CARD_GAP }}
      >
        {/* level detail tab;e */}
        <div className="w-full lg:w-[450px] !lg:max-w-[450px]">
          <LevelDetailTable
            isLoading={isclassificationDataLoading}
            data={classificationData}
            error={error as string}
          />
        </div>

        {/* first stats card */}
        <div
          className={`flex-1 grid gap-4 w-full [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))] lg:min-w-full aggregate-stat-card-style`}
          style={{
            gap: CARD_GAP,
            // gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          }}
        >
          {renderStatsCards(transformedData, 8)}
        </div>
      </div>
      {/* voltage profile vharts */}
      <div
        className="flex flex-wrap justify-between w-full"
        style={{ gap: CARD_GAP }}
      >
        {/* <EnergyLossChart /> */}
        <LoadProfileChart
          //   params={{ start_date: startDate, end_date: endDate }}
          route={`/operations/classification-profile-chart/${level_id}`}
          queryKey={["/operations", "fetchLevelLoadProfile", level_id]}
          title={t("chart.load_profile")}
        />

        {/* <EnergyChart /> */}
      </div>
      {/* stats card and gauge charts */}

      <div className="flex justify-between w-full" style={{ gap: CARD_GAP }}>
        <VoltageProfileChart
          queryKey={["/operations", "fetchLevelVoltageProfile", level_id]}
          route={`/operations/classification-voltage-profile-chart/${level_id}`}
          //   title="Voltage Profile (kV)"
        />
      </div>
      <div className="flex justify-between w-full" style={{ gap: CARD_GAP }}>
        <CurrentProfileChart
          queryKey={["/operations", "fetchLevelCurrentProfile", level_id]}
          route={`/operations/classification-current-profile-chart/${level_id}`}
        />
      </div>
    </div>
  );
};
